import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	textField: {
		width: '100%',
		backgroundColor: '#D7DBDD',
		marginTop: '1rem !important'
	},
	device: {
		magin: '4rem',
		padding: '1rem',
		marginTop: '2rem',
		marginLeft: '15rem'
	},
	deviceConfig: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		backgroundColor: theme.palette.secondary.main,
		padding: '2rem',
		borderRadius: '5px',
		width: '60%',
		marginTop: '1rem'
	},
	floatingOnlyDevice: {
		padding: '1rem',
		marginTop: '2rem',
		display: 'flex'
	},
	floatingOnlyDeviceConfig: {
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: theme.palette.secondary.main,
		borderRadius: '5px',
		margin: '2rem',
		border: '1px solid grey',
		padding: '4rem'
	}
}));
